import { Component, Injectable, OnInit } from '@angular/core';
import { PageComponent } from '../page/page.component';

@Injectable()
export abstract class IsComponent extends PageComponent {
}